module.exports = __webpack_public_path__ + "img/20_77.1a3b9300.png";